import { EButtonVariant, EButtonStyleVariant } from './enums'
import { buildButtonClassName } from './utils'
import type { ButtonProps } from './types'

export const Button = ({
  children,
  className = '',
  variant = EButtonVariant.LINK,
  buttonVariant = EButtonStyleVariant.PRIMARY,
  ...props
}: ButtonProps) => {
  const fullClassName = buildButtonClassName({
    variant,
    buttonVariant,
    className,
  })

  if ('href' in props) {
    const { href, ...anchorProps } = props
    return (
      <a href={href} className={fullClassName} {...anchorProps}>
        {children}
      </a>
    )
  }

  const { type = 'button', ...buttonProps } = props
  return (
    <button type={type} className={fullClassName} {...buttonProps}>
      {children}
    </button>
  )
}
